export var getButtonProps = function getButtonProps(isButton) {
  return isButton ? {
    role: 'button',
    tabIndex: 0
  } : {};
};